import { render, staticRenderFns } from "./DxSideBySideBar.vue?vue&type=template&id=0a8dbc43&"
import script from "./DxSideBySideBar.vue?vue&type=script&lang=js&"
export * from "./DxSideBySideBar.vue?vue&type=script&lang=js&"
import style0 from "./DxSideBySideBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports